// Cours de Base du Jour : référence quotidienne du prix de l'huile, saisie depuis la
// Vue d'ensemble. Chaque bon « À négocier » en garde une photo figée et horodatée.
const KEY = 'oliva.cours';

const DEFAUT = { noble: 11.5, lampante: 7, le: null, par: null, historique: [] };

const lire = () => ({ ...DEFAUT, ...JSON.parse(localStorage.getItem(KEY) ?? '{}') });
const ecrire = (v) => {
  localStorage.setItem(KEY, JSON.stringify(v));
  window.dispatchEvent(new Event('cours-maj'));
};

export function getCoursDuJour() {
  return lire();
}

export function setCoursDuJour({ noble, lampante, par }) {
  const actuel = lire();
  const n = Number(noble);
  const l = Number(lampante);
  if (!(n > 0) || !(l > 0)) return { error: 'Les deux cours doivent être strictement positifs.' };
  const suivant = {
    noble: Number(n.toFixed(3)),
    lampante: Number(l.toFixed(3)),
    le: new Date().toISOString(),
    par: par ?? null,
    historique: [
      {
        le: new Date().toISOString(),
        par: par ?? null,
        noble: Number(n.toFixed(3)),
        lampante: Number(l.toFixed(3)),
        ancienNoble: actuel.noble,
        ancienLampante: actuel.lampante,
      },
      ...(actuel.historique ?? []),
    ].slice(0, 200),
  };
  ecrire(suivant);
  return { error: null, cours: suivant };
}

// Photo figée au moment de la création d'un bon « À négocier » : elle ne bouge plus,
// même si le cours global est modifié ensuite.
export function figerCours(famille, par) {
  const c = lire();
  const lampante = famille === 'lampante';
  return {
    noble: c.noble,
    lampante: c.lampante,
    famille: lampante ? 'lampante' : 'noble',
    prixApplique: lampante ? c.lampante : c.noble,
    le: new Date().toISOString(),
    par: par ?? null,
  };
}
